"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recipientAnalyticsUpdate = exports.recipientAnalyticsScore = exports.recipientAnalyticsSave = exports.recipientAnalyticsRecentActivity = exports.recipientAnalyticsLatestSessionRecording = exports.recipientAnalyticsGet = exports.recipientAnalyticsFind = exports.recipientAnalyticsActivityLogHistory = exports.changeLogModuleList = exports.changeLogMediumList = exports.changeLogListPlatform = exports.changeLogList = exports.changeLogComponentList = exports.changeLogChangesPerformedList = exports.changeLogActorList = exports.analyticSuccess = exports.analyticSnapshotListReset = exports.analyticReset = exports.analyticFetchRecordScore = exports.analyticError = exports.analyticChangeLogListReset = exports.analyticActiveSnapshoptList = exports.analyticActiveLogListForAnalyticeData = exports.analyticActiveLogList = void 0;
var _analytic = require("./analytic.constant");
// @flow

// common success
var analyticSuccess = function analyticSuccess(actionType, data) {
  return {
    type: _analytic.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.analyticSuccess = analyticSuccess;
var analyticError = function analyticError(actionType, error) {
  return {
    type: _analytic.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.analyticError = analyticError;
var analyticActiveLogList = function analyticActiveLogList(data) {
  return {
    type: _analytic.actionTypes.LIST,
    payload: data
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.analyticActiveLogList = analyticActiveLogList;
var analyticActiveLogListForAnalyticeData = function analyticActiveLogListForAnalyticeData(data) {
  return {
    type: _analytic.actionTypes.LIST_ANALYTICS_DATA,
    payload: data
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.analyticActiveLogListForAnalyticeData = analyticActiveLogListForAnalyticeData;
var analyticActiveSnapshoptList = function analyticActiveSnapshoptList(data) {
  return {
    type: _analytic.actionTypes.SNAPSHOT_LIST,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.analyticActiveSnapshoptList = analyticActiveSnapshoptList;
var analyticReset = function analyticReset(data) {
  return {
    type: _analytic.actionTypes.RESET,
    payload: data
  };
};
/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.analyticReset = analyticReset;
var analyticSnapshotListReset = function analyticSnapshotListReset(data) {
  return {
    type: _analytic.actionTypes.RESET_SNAPSHOT,
    payload: data
  };
};
/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.analyticSnapshotListReset = analyticSnapshotListReset;
var analyticChangeLogListReset = function analyticChangeLogListReset(data) {
  return {
    type: _analytic.actionTypes.RESET_CHANGE_LOG,
    payload: data
  };
};

/**
 * fetch score
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.analyticChangeLogListReset = analyticChangeLogListReset;
var analyticFetchRecordScore = function analyticFetchRecordScore(data) {
  return {
    type: _analytic.actionTypes.FETCH_RECORD_SCORE,
    payload: data
  };
};

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.analyticFetchRecordScore = analyticFetchRecordScore;
var changeLogList = function changeLogList(data) {
  return {
    type: _analytic.actionTypes.CHANGE_LOG_LIST,
    payload: data
  };
};

/**
 * list platform
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.changeLogList = changeLogList;
var changeLogListPlatform = function changeLogListPlatform(data) {
  return {
    type: _analytic.actionTypes.CHANGE_LOG_LIST_PLATFORM,
    payload: data
  };
};

/**
 * list changes performed
 * @param payload
 * @returns api response
 * @description this function used to get data of change log changes performed.
 */
exports.changeLogListPlatform = changeLogListPlatform;
var changeLogChangesPerformedList = function changeLogChangesPerformedList(data) {
  return {
    type: _analytic.actionTypes.CHANGE_LOG_CHANGES_PERFORMED_LIST,
    payload: data
  };
};

/**
 * list change log medium
 * @param payload
 * @returns api response
 * @description this function used to get data of change log medium list.
 */
exports.changeLogChangesPerformedList = changeLogChangesPerformedList;
var changeLogMediumList = function changeLogMediumList(data) {
  return {
    type: _analytic.actionTypes.CHANGE_LOG_MEDIUM_LIST,
    payload: data
  };
};

/**
 * list change log module
 * @param payload
 * @returns api response
 * @description this function used to get data of change log module list.
 */
exports.changeLogMediumList = changeLogMediumList;
var changeLogModuleList = function changeLogModuleList(data) {
  return {
    type: _analytic.actionTypes.CHANGE_LOG_MODULE_LIST,
    payload: data
  };
};

/**
 * list change log component
 * @param payload
 * @returns api response
 * @description this function used to get data of change log component list.
 */
exports.changeLogModuleList = changeLogModuleList;
var changeLogComponentList = function changeLogComponentList(data) {
  return {
    type: _analytic.actionTypes.CHANGE_LOG_COMPONENT_LIST,
    payload: data
  };
};

/**
 * list change log actor
 * @param payload
 * @returns api response
 * @description this function used to get data of change log actor list.
 */
exports.changeLogComponentList = changeLogComponentList;
var changeLogActorList = function changeLogActorList(data) {
  return {
    type: _analytic.actionTypes.CHANGE_LOG_ACTOR_LIST,
    payload: data
  };
};

// Analytics recipient

/**
 * Analytics Save
 * @param payload
 * @returns api response
 * @description this function used to Analytics Save.
 */
exports.changeLogActorList = changeLogActorList;
var recipientAnalyticsSave = function recipientAnalyticsSave(data) {
  return {
    type: _analytic.actionTypes.ANALYTICS_SAVE,
    payload: data
  };
};

/**
 * Analytics Get
 * @param payload
 * @returns api response
 * @description this function used to Analytics Get.
 */
exports.recipientAnalyticsSave = recipientAnalyticsSave;
var recipientAnalyticsGet = function recipientAnalyticsGet(data) {
  return {
    type: _analytic.actionTypes.ANALYTICS_GET,
    payload: data
  };
};

/**
 * Analytics Update
 * @param payload
 * @returns api response
 * @description this function used to Analytics Update.
 */
exports.recipientAnalyticsGet = recipientAnalyticsGet;
var recipientAnalyticsUpdate = function recipientAnalyticsUpdate(data) {
  return {
    type: _analytic.actionTypes.ANALYTICS_UPDATE,
    payload: data
  };
};

/**
 * Analytics Recent Activity
 * @param payload
 * @returns api response
 * @description this function used to Analytics Recent Activity.
 */
exports.recipientAnalyticsUpdate = recipientAnalyticsUpdate;
var recipientAnalyticsRecentActivity = function recipientAnalyticsRecentActivity(data) {
  return {
    type: _analytic.actionTypes.ANALYTICS_RECENT_ACTIVITY,
    payload: data
  };
};

/**
 * Analytics Find
 * @param payload
 * @returns api response
 * @description this function used to Analytics Find.
 */
exports.recipientAnalyticsRecentActivity = recipientAnalyticsRecentActivity;
var recipientAnalyticsFind = function recipientAnalyticsFind(data) {
  return {
    type: _analytic.actionTypes.ANALYTICS_FIND,
    payload: data
  };
};

/**
 * Analytics Activity Log History
 * @param payload
 * @returns api response
 * @description this function used to Analytics Activity Log History.
 */
exports.recipientAnalyticsFind = recipientAnalyticsFind;
var recipientAnalyticsActivityLogHistory = function recipientAnalyticsActivityLogHistory(data) {
  return {
    type: _analytic.actionTypes.ANALYTICS_ACTIVITY_LOG_HISTORY,
    payload: data
  };
};

/**
 * Analytics Latest Session Recording
 * @param payload
 * @returns api response
 * @description this function used to Analytics Latest Session Recording.
 */
exports.recipientAnalyticsActivityLogHistory = recipientAnalyticsActivityLogHistory;
var recipientAnalyticsLatestSessionRecording = function recipientAnalyticsLatestSessionRecording(data) {
  return {
    type: _analytic.actionTypes.ANALYTICS_LATEST_SESSION_RECORDING,
    payload: data
  };
};

/**
 * Analytics Score
 * @param payload
 * @returns api response
 * @description this function used to Analytics Score.
 */
exports.recipientAnalyticsLatestSessionRecording = recipientAnalyticsLatestSessionRecording;
var recipientAnalyticsScore = function recipientAnalyticsScore(data) {
  return {
    type: _analytic.actionTypes.ANALYTICS_SCORE,
    payload: data
  };
};
exports.recipientAnalyticsScore = recipientAnalyticsScore;